export default "__VITE_ASSET__BlaIsFRW__"